import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  OnInit,
} from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  ReactiveFormsModule,
  UntypedFormGroup,
} from '@angular/forms';
import {
  CheckoutFeature,
  TermsAndConditionsTestHooks,
} from '@checkout/util-models';
import { QuoteDetails } from '@domgen/dgx-fe-basket';
import {
  CmsBrandIpidPipe,
  CmsBrandTermsAndConditionsPipe,
} from '@domgen/dgx-fe-cms';
import { ContractType, ProductType } from '@domgen/dgx-fe-common';
import { TestHookDirective } from '@domgen/dgx-fe-components/general';
import { FeatureEnabledDirective } from '@domgen/dgx-fe-config';
import { CheckboxComponent } from '@domgen/dgx-fe-forms/checkbox';
import {
  FormField,
  FormFieldComponent,
  FormFieldsetComponent,
  FormNoteComponent,
  FormRowComponent,
} from '@domgen/dgx-fe-forms/layout';
import {
  provideTranslationDictionaryMapping,
  TranslatePipe,
} from '@domgen/dgx-fe-i18n';
import { translation } from './i18n/translation.constant';

@Component({
  standalone: true,
  selector: 'checkout-terms-and-conditions-fieldset',
  templateUrl: './terms-and-conditions-fieldset.component.html',
  providers: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
    {
      provide: FormFieldsetComponent,
      useExisting: forwardRef(() => TermsAndConditionsFieldsetComponent),
    },
    provideTranslationDictionaryMapping(translation),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CheckboxComponent,
    CmsBrandIpidPipe,
    CmsBrandTermsAndConditionsPipe,
    CommonModule,
    FeatureEnabledDirective,
    FormFieldComponent,
    FormFieldsetComponent,
    FormNoteComponent,
    FormRowComponent,
    ReactiveFormsModule,
    TestHookDirective,
    TranslatePipe,
  ],
})
export class TermsAndConditionsFieldsetComponent
  extends FormFieldsetComponent
  implements OnInit
{
  @Input() legendNoteIPID?: string;
  @Input() quotes?: QuoteDetails[];
  @Input() termsAndConditionsField?: FormField;

  form!: UntypedFormGroup;
  testHooks = TermsAndConditionsTestHooks;
  ipidFeature = CheckoutFeature.Ipid;

  constructor(protected controlContainer: FormGroupDirective) {
    super();
  }

  ngOnInit(): void {
    this.form = this.controlContainer.form;
  }

  get isInsuranceContractType(): boolean | undefined {
    return this.quotes?.some(
      ({ contractTypeCode }) => contractTypeCode === ContractType.Insurance
    );
  }

  get termsAndConditionsLegendNote(): string {
    return this.quotes?.some(
      ({ productType }) => productType === ProductType.PlumbingAndDrainage
    )
      ? 'CHECKOUT_TERMS_AND_CONDITIONS_PANDD_LEGEND_NOTE'
      : 'CHECKOUT_TERMS_AND_CONDITIONS_LEGEND_NOTE';
  }
}
